import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SequencesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Sequences",
    children: /*#__PURE__*/_jsx("path", {
      d: "M18.26 11.08c1.25 0 2.27-1.02 2.27-2.27V4.28c0-1.26-1.02-2.28-2.27-2.28h-4.53c-1.25 0-2.26 1.02-2.26 2.27V8.8c0 1.25 1.02 2.27 2.27 2.27h.76v2.01h-.76c-1.25 0-2.27 1.02-2.27 2.27v4.53c0 1.25 1.02 2.27 2.27 2.27h.76v2.02h-2.28a.77.77 0 0 0-.65 1.18s3.74 4.27 3.74 4.27c.13.23.38.38.66.38s.53-.15.66-.38 3.74-4.27 3.74-4.27c.08-.12.13-.26.13-.42a.77.77 0 0 0-.77-.77h-2.22v-2.01h.76c1.25 0 2.27-1.02 2.27-2.27v-4.53c0-1.25-1.02-2.27-2.27-2.27h-.76v-2.01h.75Zm-.76 8.05h-3.02v-3.02h3.02zM14.48 8.05V5.03h3.02v3.02z"
    })
  }));
};